/*
 * Lib Module Upload
 */

Lib.Upload = (function() {
    var self = {};

    // Disable auto discover for all dropzone elements:
    Dropzone.autoDiscover = false;

    // Document ready
    $(Lib).on('document.ready', function() {
        self.initializeDropzones($('div[data-dropzone]'));
    });

    /**
     * Initialize dropzones
     * @param dropzones
     */
    self.initializeDropzones = function(dropzones) {

        var dropZoneForms = dropzones.closest('form');
        var uploadCallback = new Lib.CounterCallback(function() {
            if (typeof dropZoneForms.data('no-upload-submit') === 'undefined') {
                dropZoneForms.data('allowedsubmit', true);
                if (dropZoneForms.data('submitqueued')) {
                    dropZoneForms.submit();
                }
            }
        });

        dropzones.each(function() {
            var zone = $(this);
            if (zone.data('isDropzoned') !== true) {
                var dzSettings = zone.data('dropzone');
                var clickables = zone.parent().parent().parent().find('.label-control label, span.input-suffix, span.input-prefix').get();
                clickables.push(zone[0]);

                var settings = $.extend({
                    parallelUploads: 1,
                    maxFilesize: 50,
                    uploadMultiple: false,
                    addRemoveLinks: true,
                    createImageThumbnails: false,
                    timeout: 60000 * 30, // 30 minutes
                    dictDefaultMessage: 'Selecteer een bestand...',
                    dictRemoveFile: '',
                    dictCancelUpload: 'Annuleren',
                    dictInvalidFileType: 'Foutief bestandstype',
                    url: '/uploads/upload_tmp.json',
                    previewTemplate: '<div style="display: none;"></div>',
                    clickable: clickables,
                    init: function() {

                        var dz = this;

                        var dzElement = $(dz.element);
                        var hiddenInput = dzElement.find(':input:hidden').first();
                        var hiddenInputFilename = dzElement.find(':input:hidden').last();
                        var msg = dzElement.find('.dz-message span');
                        var suffix = dzElement.parent().find('.input-suffix');
                        var addonGroup = dzElement.parent();
                        var inputControl = addonGroup.parent();
                        var wrapperDiv = inputControl.parent();
                        var defaultText = msg.text();
                        var defaultSuffixText = '';

                        if (hiddenInputFilename.val() !== '') {
                            msg.text(hiddenInputFilename.val());
                            defaultText = hiddenInputFilename.val();
                            defaultSuffixText = '<i class="is-icon material-icons" data-tooltip="Vervang bestand">edit</i>';
                            suffix.html(defaultSuffixText);
                        }

                        dzElement.on('dropzone:reset', function() {
                            msg.text(defaultText);
                            hiddenInput.val('');
                            hiddenInputFilename.val('');
                            dzElement.parent().find('.progress').css('width', '0px').hide();
                            suffix.html(defaultSuffixText);
                        });

                        this.on('queuecomplete', function() {
                            dzElement.parent().find('.progress').hide();
                            dz.removeAllFiles();
                        });

                        this.on('sending', function(file, xhr, formdata) {
                            xhr.ontimeout = function(e) {
                                triggerError('Het uploaden duurde te lang!');
                                uploadCallback.decrease();
                            };

                            uploadCallback.increase();
                            dropZoneForms.data('allowedsubmit', false);
                            $.each(dzSettings.data, function(k, v) {
                                formdata.append(k, v);
                            });

                            wrapperDiv.removeClass('error');
                            wrapperDiv.find('.error-message').remove();

                            msg.html('Bezig met uploaden...');

                            msg.removeClass('text-danger');

                            suffix.empty();

                        });

                        this.on('success', function(file, result) {

                            // Show the file name and the green checkmark
                            suffix.html('<i class="is-icon material-icons text-success text-bold">check</i>');
                            msg.text(file.name);

                            if (typeof result === 'object') {
                                if ('tmp_id' in result && result.tmp_id && !result.errorMessage) {

                                    hiddenInput.val(result.tmp_id);

                                    if ('name' in result && result.name) {
                                        hiddenInputFilename.val(result.name);
                                    }

                                    uploadCallback.decrease();
                                } else if (result.errorMessage) {
                                    return triggerError(result.errorMessage);
                                }
                            } else {
                                triggerError('Fout, neem contact op met VASTGOEDflow');
                            }
                        });

                        this.on('error', function(file, error) {
                            triggerError(error);
                            uploadCallback.decrease();
                        });

                        this.on('addedfile', function() {
                            if (!this.options.uploadMultiple) {
                                if (this.files[1] != null) {
                                    this.removeFile(this.files[0]);
                                }
                            }
                        });

                        this.on('uploadprogress', function(file, progress) {
                            var parentWidth = dzElement.parent().outerWidth();
                            var progressWidth = (parentWidth / 100) * progress;

                            if (progress === 100) {
                                progressWidth = 0;
                            }

                            dzElement.parent().find('.progress').css('width', progressWidth).show();
                        });

                        var triggerError = function(txt) {

                            if ($.isPlainObject(txt) || txt.length > 200) {
                                Lib.Debug.warn('Error in dropzone', txt);
                                txt = 'Fout, neem contact op met VASTGOEDflow';
                            }

                            wrapperDiv.addClass('error');
                            var errorMsg = wrapperDiv.find('.error-message');

                            if (!errorMsg.length) {
                                errorMsg = $('<div />').addClass('error-message').appendTo(inputControl);
                            }

                            errorMsg.text(txt);

                            msg.addClass('text-danger').text(dz.options.dictDefaultMessage);
                            suffix.html('<i class="is-icon material-icons text-danger">close</i>');

                            hiddenInput.val('');
                            hiddenInputFilename.val('');
                        };

                    }
                }, dzSettings);

                if ('url' in settings) {
                    zone.dropzone(settings).addClass('dropzone').data('isDropzoned', true);
                }
            }
        });
    };

    return self;

})();
